var SvcsScreenOtherMeal = (function ($) {

    SvcsScreenOtherMeal = function (options) {
        var that = this;

        that.class = {
            is_active: 'is-active',
            sticky: 'sticky',

            svc_action: 'js-svc-action',
            svc_action_add: 'js-svc-action-add',
            svc_action_edit: 'js-svc-action-edit',
            svc_action_submit: 'js-svc-action-submit',
            svc_action_submit_text_desktop: 'js-svc-action-submit-text-desktop',
            svc_action_submit_text_mobile: 'js-svc-action-submit-text-mobile',
            svc_action_confirm: 'js-svc-action-confirm',
            svc_action_cancel: 'js-svc-action-cancel',
            svc_title: 'js-svc-title',
            svc_sub_title: 'js-svc-sub-title',
            svc_content: 'js-svc-content',
            svc_total: 'js-svcs-meal-total-value',
            svc_card_wrapper: 'js-svc-card-wrapper',
            svc_border: 'js-svcs-border',
            svc_badge_added: 'js-svc-badge-added',
            svc_badge_added_quantity: 'js-svc-badge-added-quantity',
            svc_badge_paid: 'js-svc-badge-paid',
            svc_badge_paid_quantity: 'js-svc-badge-paid-quantity',

            svc_meal_categories: 'js-svc-meal-categories',
            svc_meal_category: 'js-svc-meal-category',
            svc_segment_tab_content: 'js-tab-content',

            svc_hint: 'js-svc-hint',
            svc_hint_top: 'top'
        };

        that.selectors = {
            select_segment_passengers: UISelectSegmentPassengers.prototype.selectors.select_segment_passengers,
        };

        // DOM
        that.$wrapper = options['$wrapper'];

        that.analytics_dataset = options.analytics_dataset || null;

        if (that.$wrapper && that.$wrapper.length) {
            // CONST
            that.items_unpaid_initial_count = that.__countItemsQuantity(options['items_unpaid'] || []);
            that.order_currency = options['order_currency'] || '';

            // DYNAMIC VARS
            that.items_unpaid = [];
            that.items_paid = options['items_paid'] || [];
            that.total = options['total'] || 0;

            // HANDLERS
            that.onPassengerSelected = (options['onPassengerSelected'] || function () {
            });
            that.onPassengerReset = (options['onPassengerReset'] || function () {
            });
            that.onButtonConfirmClick = (options['onButtonConfirmClick'] || function () {
            });
            that.onButtonCancelClick = (options['onButtonCancelClick'] || function () {
            });

            // COMPONENTS

            // {
            //     segment_id: {
            //         svc_id: UISelectSegmentPassengers
            //     }
            // }
            that.select_segment_passengers_desktop = {};
            // UISelectSegmentPassengers[]
            that.select_segment_passengers_mobile = [];

            // INIT
            that.init(options);
        }
    }

    SvcsScreenOtherMeal.prototype.init = function (options = {}) {
        var that = this;

        //
        that.svcMealFilter();
        //
        // hide badge 'Added' for all svcs
        that.__badgeToggle('added', false);
        //
        // hide badge 'Paid' for all svcs
        that.__badgeToggle('paid', false);
        //
        // set default state to action buttons in cards
        that.__setSvcsActionState(that.$wrapper.find('.' + that.class.svc_card_wrapper), 'add');
        //
        // show paid items
        that.showInitialSvcsPaid();
        //
        // select initial svcs
        that.initSelectSegmentPassengersDesktop(
            that.$wrapper.find(that.selectors.select_segment_passengers),
            options['items_unpaid'] || []
        );
        //
        that.svcActionHandler();
        //
        that.svcActionSubmitHandler();
        //
        // Set submit button text
        // (must be after initSelectSegmentPassengersDesktop(), because here we're going to override the text,
        // which was set on select during the SelectSegmentPassengers initialization)
        that.__setInitialSubmitActionState();
        //
        that.__svcAirlineToggleHintPosition();
        //
        that.__analyticsEmitViewItemListEvent();

        that.__initSegmentTabs();
    };

    SvcsScreenOtherMeal.prototype.__setInitialSubmitActionState = function () {
        var that = this;
        // if there were any unpaid items on init - set Confirm state
        if (that.items_unpaid_initial_count > 0) {
            that.__setActionSubmitConfirm();
        }
        // if there were no unpaid items, but there are any paid items - set Continue state
        else if (that.items_paid && that.items_paid.length) {
            that.__setActionSubmitContinue();
        }
        // if there were no unpaid items on init, and no paid items - set Empty state
        else {
            that.__setActionSubmitEmpty();
        }
    };

    SvcsScreenOtherMeal.prototype.showInitialSvcsPaid = function () {
        var that = this,
            svcs_quantities = {};

        // collect quantities of all svcs
        for (var i = 0; i < that.items_paid.length; i++) {
            var item_id = that.items_paid[i]['item_id'],
                segment_id = that.items_paid[i]['segment_id'],
                key = item_id + ':' + segment_id;

            if (svcs_quantities.hasOwnProperty(key)) {
                continue;
            }

            svcs_quantities[key] = that.items_paid.reduce(function (qty, current) {
                if (
                    current['item_id'].toString()    === item_id.toString() &&
                    current['segment_id'].toString() === segment_id.toString()
                ) {
                    return qty + parseInt(current['item_quantity'], 10);
                } else {
                    return qty;
                }
            }, 0);
        }

        for (var quantity_key in svcs_quantities) {
            var key_parts = quantity_key.split(':'),
                svc_id = key_parts[0],
                svc_segment_id = key_parts[1];

            that.__badgeSetQuantity('paid', svc_segment_id, svc_id, svcs_quantities[quantity_key]);
            that.__badgeToggle('paid', !!svcs_quantities[quantity_key], svc_segment_id, svc_id);
        }
    };

    SvcsScreenOtherMeal.prototype.svcMealFilter = function () {
        var that = this,
            $svc_meal_category = that.$wrapper.find('.' + that.class.svc_meal_category);

        $svc_meal_category.on('click', function (e) {
            e.preventDefault();

            var $button = $(this),
                $button_wrapper = $button.parents('.' + that.class.svc_meal_categories),
                category_id = $button.data('id');

            that.__svcMealFilterChangeButtonState($button_wrapper, $button);
            that.__svcAirlineFilterToggleWrapper(category_id);
            that.__svcAirlineToggleHintPosition(category_id);

        });
    };

    SvcsScreenOtherMeal.prototype.__svcMealFilterChangeButtonState = function ($button_wrapper , $button) {
        var that = this;

        $button_wrapper.find('.' + that.class.svc_meal_category).removeClass(that.class.is_active);
        $button.addClass(that.class.is_active);
    };

    SvcsScreenOtherMeal.prototype.__svcAirlineFilterToggleWrapper = function (category_id) {
        var that = this;

        if (category_id !== 'all') {
            that.$wrapper.find('.' + that.class.svc_card_wrapper).hide();
            that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-category-id="'+ category_id +'"]').fadeIn();
        } else {
            that.$wrapper.find('.' + that.class.svc_card_wrapper).fadeIn();
        }

        that.__analyticsEmitViewItemListEvent(category_id);
    };

    /**
     * @param {string|int} category_id
     * @private
     */
    SvcsScreenOtherMeal.prototype.__analyticsEmitViewItemListEvent = function (category_id = 'all') {
        var that = this, event_data;

        if (that.analytics_dataset && that.analytics_dataset.layout === 'svc_add') {
                event_data = that.analytics_dataset.getViewItemListForType('MEAL', 0, category_id);
                if (event_data) {
                    $.sa.analytics.gtag('event', 'view_item_list', event_data);
                }
        }
    }

    SvcsScreenOtherMeal.prototype.svcActionSubmitHandler = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svc_action_submit);

        $action.on('click', function (event) {
            var $this = $(this);

            if ($this.hasClass(that.class.svc_action_confirm)) {
                that.onButtonConfirmClick(that.items_unpaid, that, event);
            } else if ($this.hasClass(that.class.svc_action_cancel)) {
                that.onButtonCancelClick(that.items_unpaid, that, event);
            }
        });
    };

    SvcsScreenOtherMeal.prototype.svcActionHandler = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svc_action);

        // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
        // THIS MUST BE BEFORE DEFAULT CALLBACK - FOR CORRECT WORK OF MOBILE VERSION
        $action.on('click', function (e) {
            var $this = $(this),
                $svc_card = $this.parents('.' + that.class.svc_card_wrapper),
                $svc_content = $svc_card.find('.' + that.class.svc_content),
                svc_segment_id = $svc_card.data('segment-id'),
                svc_id = $svc_card.data('airline-svc-id');

            // apply select only on expand
            if (UIToggle.prototype.isActive($svc_content)) {
                return;
            }

            // if svc is already selected, or force select was already performed on this svc
            if (that.items_unpaid.some(selection => (
                    selection.segment_id.toString() === svc_segment_id.toString() &&
                    selection.item_id.toString() === svc_id.toString() &&
                    (
                        parseInt(selection.item_quantity, 10) > 0 ||
                        selection.force_select
                    )
                ))
            ) {
                return;
            }

            // if svc is already paid
            if (that.items_paid && that.items_paid.some(selection => (
                    selection.segment_id.toString() === svc_segment_id.toString() &&
                    selection.item_id.toString() === svc_id.toString()
                ))
            ) {
                return;
            }

            if (!that.select_segment_passengers_desktop.hasOwnProperty(svc_segment_id)) {
                $.sa.error('select_segment_passengers for svc ID '+ svc_id + 'in segment ' + svc_segment_id + ' not found.');
                return;
            }
            if (!that.select_segment_passengers_desktop[svc_segment_id].hasOwnProperty(svc_id)) {
                $.sa.error('select_segment_passengers for svc ID '+ svc_id + 'in segment ' + svc_segment_id + ' not found.');
                return;
            }

            var select_segment_passengers = that.select_segment_passengers_desktop[svc_segment_id][svc_id];
            if (!select_segment_passengers) {
                $.sa.error('select_segment_passengers for svc ID '+ svc_id + 'in segment ' + svc_segment_id + ' not found.');
                return;
            }

            var $passengers = select_segment_passengers.getSegmentPassengersAll();

            $passengers.each(function () {
                var $passenger = $(this),
                    svc_passenger_id = select_segment_passengers.getPassengerId($passenger),
                    svc_price = select_segment_passengers.getPassengerSelectionPrice($passenger),
                    svc_quantity = 1;

                // if it's counter - add min counter value to quantity
                if (select_segment_passengers.isType(select_segment_passengers.TYPES.counter)) {
                    var min_value = select_segment_passengers.getPassengerCounterMin(svc_passenger_id);
                    svc_quantity += min_value;
                }

                if (svc_passenger_id) {
                    select_segment_passengers.select(
                        svc_passenger_id,
                        svc_id,
                        svc_price,
                        {
                            force_select: true
                        },
                        svc_quantity,
                        1
                    );
                }
            });
        });

        $action.on('click', function (e){
            e.preventDefault();

            var $this = $(this),
                $parent = $this.parents('.' + that.class.svc_card_wrapper);

            if (!$.sa.is_desktop()){
                that.__renderSvcPassengerSegmentDrawer($this, $parent);
            }

            if ($.sa.is_desktop()){
                that.__toggleSvcsContentStickyHeader($this, $parent);
            }

            if(that.analytics_dataset && that.analytics_dataset.layout === 'main') {
                var svc_id = $parent.data('airline-svc-id');

                if (svc_id) {
                    var event_data = that.analytics_dataset.getViewItemListForSingleSvc(svc_id)
                    if (event_data) {
                        $.sa.analytics.gtag('event', 'view_item_list', event_data);
                    }
                }
            }
        });
    };

    SvcsScreenOtherMeal.prototype.__renderSvcPassengerSegmentDrawer = function ($action, $parent) {
        var that = this,
            $title = $parent.find('.' + that.class.svc_title).clone(),
            $sub_title = $parent.find('.' + that.class.svc_sub_title).clone(),
            $content_wrapper = $parent.find('.' + that.class.svc_content),
            content = $content_wrapper.html(),
            footer = `<button class="button primary width-1-1 js-button-confirm">${$.sa.locales['confirm']}</button>`,
            airline_svc_id = $parent.data('airline-svc-id'),
            segment_id = $parent.data('segment-id'),
            svc_segment_quantity_initial = that.__getItemQuantity(airline_svc_id, segment_id);

        $.uiDrawer({
            position: 'bottom',
            header_title: $title,
            header_description: $sub_title,
            header_contrast: true,
            content: content,
            custom_class: 'svcs',
            footer: footer,
            fluid: true,
            disable_content_scroll: true,
            onOpen: function ($drawer_wrapper, drawer) {
                var $select_segment_passengers = $drawer_wrapper.find(that.selectors.select_segment_passengers),
                    $submit_button_drawer = $drawer_wrapper.find('.js-button-confirm'),
                    // if there are any selected items on drawer open - set Confirm state, otherwise - set Empty state
                    submit_button_state_initial = (svc_segment_quantity_initial > 0) ? 'confirm' : 'empty';

                that.initSelectSegmentPassengersMobile(
                    $select_segment_passengers,
                    $drawer_wrapper,
                    $submit_button_drawer,
                    svc_segment_quantity_initial,
                    submit_button_state_initial
                );
                that.__setSegmentDrawerActionSubmitState(submit_button_state_initial, $submit_button_drawer);
            },
            onClose: function (drawer) {
                that.clearSelectSegmentPassengersMobile();
            }
        });
    };

    SvcsScreenOtherMeal.prototype.initSelectSegmentPassengersDesktop = function (
        $select_segment_passengers,
        selected_items_unpaid = []
    ) {
        var that = this,
            options;

        options = {
            items_unpaid: selected_items_unpaid,
            items_paid: that.items_paid,
            onPassengerSelected: function (data, component) {
                that.__onSelect(data);
            },
            onPassengerReset: function (data, call_callback_after, component) {
                that.__onReset(data);
            },
        };

        $select_segment_passengers.each(function () {
            var $card_wrapper = $(this).parents('.' + that.class.svc_card_wrapper),
                $card_content = $card_wrapper.find('.' + that.class.svc_content),
                airline_svc_id = $card_wrapper.data('airline-svc-id'),
                segment_id = $(this).data('segment-id');

            if (!that.select_segment_passengers_desktop.hasOwnProperty(segment_id)) {
                that.select_segment_passengers_desktop[segment_id] = {};
            }
            if (!that.select_segment_passengers_desktop[segment_id].hasOwnProperty(airline_svc_id)) {
                that.select_segment_passengers_desktop[segment_id][airline_svc_id] = new UISelectSegmentPassengers(Object.assign({}, options, {$wrapper: $(this), $container: $card_content}));
            }
        });
    };

    SvcsScreenOtherMeal.prototype.initSelectSegmentPassengersMobile = function (
        $select_segment_passengers,
        $container,
        $submit_button,
        quantity_initial,
        submit_button_state_initial
    ) {
        var that = this,
            options;

        options = {
            $container: $container,
            onPassengerSelected: function (data, component) {
                // apply select on desktop Passengers Selectors
                var applyOnDesktop = function (data) {
                    var select_segment_passengers = that.select_segment_passengers_desktop[data.segment_id][data.item_id];
                    if (select_segment_passengers.isThatSegment(data.segment_id)) {
                        var selected_quantity = parseInt(data['item_quantity'], 10),
                            // if it's counter - add min counter value to quantity
                            quantity = select_segment_passengers.isType(select_segment_passengers.TYPES.counter)
                                ? selected_quantity + select_segment_passengers.getPassengerCounterMin(data['passenger_id'])
                                : selected_quantity;

                        select_segment_passengers.select(
                            data['passenger_id'],
                            data['item_id'],
                            data['item_price'],
                            {
                                item_text: data['item_text']
                            },
                            quantity,
                            data['item_quantity_diff']
                        );
                    }
                };

                if (!Array.isArray(data)) {
                    applyOnDesktop(data);
                } else {
                    data.forEach(function (data_item) {
                        // need to pass exactly component's segment_id IMPORTANT
                        applyOnDesktop(data_item);
                    });
                }

                var quantity = Array.isArray(data)
                    ? that.__getItemQuantity(data[0]['item_id'], data[0]['segment_id'])
                    : that.__getItemQuantity(data['item_id'], data['segment_id']);

                // Update submit button state
                if (quantity === quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState(submit_button_state_initial, $submit_button);
                } else if (quantity < quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState('confirm', $submit_button);
                } else {
                    that.__setSegmentDrawerActionSubmitState('added', $submit_button);
                }
            },
            onPassengerReset: function (data, call_callback_after, component) {
                // apply reset on desktop Passengers Selectors
                var applyOnDesktop = function (data) {
                    var select_segment_passengers = that.select_segment_passengers_desktop[data.segment_id][data.item_id];
                    if (select_segment_passengers.isThatSegment(data.segment_id)) {
                        var $passenger = select_segment_passengers.getPassengerById(data.passenger_id),
                            $selection = select_segment_passengers.getPassengerSelection($passenger);
                        select_segment_passengers.reset($selection, call_callback_after);
                    }
                };

                if (!Array.isArray(data)) {
                    applyOnDesktop(data);
                } else {
                    applyOnDesktop(data);
                }

                var quantity = Array.isArray(data)
                    ? that.__getItemQuantity(data[0]['item_id'], data[0]['segment_id'])
                    : that.__getItemQuantity(data['item_id'], data['segment_id']);

                // Update submit button state
                if (quantity === 0) {
                    that.__setSegmentDrawerActionSubmitState('empty', $submit_button);
                } else if (quantity === quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState(submit_button_state_initial, $submit_button);
                } else if (quantity > quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState('added', $submit_button);
                } else {
                    that.__setSegmentDrawerActionSubmitState('confirm', $submit_button);
                }
            }
        };

        $select_segment_passengers.each(function () {
            that.select_segment_passengers_mobile.push(
                new UISelectSegmentPassengers(Object.assign({}, options, {$wrapper: $(this)}))
            );
        });
    };

    SvcsScreenOtherMeal.prototype.clearSelectSegmentPassengersMobile = function () {
        var that = this;
        that.select_segment_passengers_mobile = [];
    };

    SvcsScreenOtherMeal.prototype.__onSelect = function (data) {
        var that = this,
            quantity_all;

        var onSelectItem = function (data_item) {
            var quantity_item;

            that.__saveSvc(data_item);

            // get new item quantity after update
            quantity_item = that.__getItemQuantity(data_item.item_id, data_item.segment_id);

            that.__setSvcActionStateFor(
                data_item['segment_id'],
                data_item['item_id'],
                quantity_item
            );

            // toggle badge 'Added'
            that.__badgeSetQuantity('added', data_item.segment_id, data_item.item_id, quantity_item);
            that.__badgeToggle('added', !!quantity_item, data_item.segment_id, data_item.item_id);
        };

        if (Array.isArray(data)) {
            data.forEach(function (data_item) {
                onSelectItem(data_item);
            });
        } else {
            onSelectItem(data);
        }

        that.__displayTotal();

        quantity_all = that.__getQuantityAll(); // get all Meal quantity after collection update
        // Update submit button state
        // if quantity was set to initial value - set initial state
        if (quantity_all === that.items_unpaid_initial_count) {
            that.__setInitialSubmitActionState();
        }
        // if current quantity is lesser than initial one - set Confirm state
        else if (quantity_all < that.items_unpaid_initial_count) {
            that.__setActionSubmitConfirm();
        }
        // if current quantity is greater than initial one - set Add state
        else {
            that.__setActionSubmitAdd();
        }

        that.onPassengerSelected(data, that);
    };

    SvcsScreenOtherMeal.prototype.__onReset = function (data) {
        var that = this,
            quantity_all;

        var onResetItem = function (data_item) {
            var quantity_item;

            that.__resetSvc(data_item);

            // get new item quantity after update
            quantity_item = that.__getItemQuantity(data_item.item_id, data_item.segment_id);

            that.__setSvcActionStateFor(
                data_item['segment_id'],
                data_item['item_id'],
                quantity_item
            );

            // toggle badge 'Added'
            that.__badgeSetQuantity('added', data_item.segment_id, data_item.item_id, quantity_item);
            that.__badgeToggle('added', !!quantity_item, data_item.segment_id, data_item.item_id);
        };

        if (Array.isArray(data)) {
            data.forEach(function (data_item) {
                onResetItem(data_item);
            });
        } else {
            onResetItem(data);
        }

        that.__displayTotal();

        quantity_all = that.__getQuantityAll(); // get all Meal quantity after collection update
        // Update submit button state
        if (quantity_all === 0) {
            if (that.items_paid && that.items_paid.length) {
                that.__setActionSubmitConfirm();
            } else {
                that.__setActionSubmitEmpty();
            }
        }
        // if quantity was dropped to initial value - set initial state
        else if (quantity_all === that.items_unpaid_initial_count) {
            that.__setInitialSubmitActionState();
        }
        // if quantity was dropped, but current quantity is still greater than initial one - set Add state
        else if (quantity_all > that.items_unpaid_initial_count) {
            that.__setActionSubmitAdd();
        }
        // if quantity was dropped, and current quantity is lesser than initial one - set Confirm state
        else {
            that.__setActionSubmitConfirm();
        }

        that.onPassengerReset(data, that);
    };

    SvcsScreenOtherMeal.prototype.__saveSvc = function (data) {
        var that = this,
            item_changed_index = that.items_unpaid.length ? that.items_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString()
                )
            ) : -1,
            quantity = parseInt(data.item_quantity, 10),
            quantity_diff = parseInt(data.item_quantity_diff, 10),
            price = parseFloat(data.item_price);

        // if item is already saved, update quantity
        if (item_changed_index !== -1) {
            that.items_unpaid[item_changed_index]['item_quantity'] = quantity;
            that.items_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;

            // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
            if (data.hasOwnProperty('force_select')) {
                that.items_unpaid[item_changed_index]['force_select'] = data.force_select;
            }
        } else {
            that.items_unpaid.push(data);
        }

        that.__changeTotal(price, quantity_diff);
    };

    SvcsScreenOtherMeal.prototype.__resetSvc = function (data) {
        var that = this,
            item_changed_index = that.items_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString()
                )
            ),
            quantity = data.item_quantity ? parseInt(data.item_quantity, 10) : 0,
            quantity_diff = data.item_quantity_diff ? parseInt(data.item_quantity_diff, 10) : 0,
            price = parseFloat(data.item_price);

        // remove item
        if (item_changed_index === -1) {
            $.sa.log('Error reset meal: not exists in set of selections');
            return;
        }

        that.items_unpaid[item_changed_index]['item_quantity'] = quantity;
        that.items_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;

        that.__changeTotal(price, quantity_diff);
    };

    SvcsScreenOtherMeal.prototype.__getItemQuantity = function (item_id, segment_id) {
        var that = this,
            items = that.items_unpaid.filter(selection => (
                selection.segment_id.toString() === segment_id.toString() &&
                selection.item_id.toString()    === item_id.toString()
            ));
        return that.__countItemsQuantity(items);
    };

    SvcsScreenOtherMeal.prototype.__getQuantityAll = function () {
        var that = this;
        return that.__countItemsQuantity(that.items_unpaid);
    };

    SvcsScreenOtherMeal.prototype.__countItemsQuantity = function (items) {
        var quantity = 0;
        items.forEach(function (selection) {
            quantity += (selection.hasOwnProperty('item_quantity') ? parseInt(selection.item_quantity, 10) : 0);
        });
        return quantity;
    };

    /**
     * Toggle (show or hide) badge 'Added' for specified svc, depending on specified state
     * @param {String} type
     * @param {Boolean} state Show or hide badge
     * @param {String|int|null} segment_id If not specified - toggle badges for all svcs on page
     * @param {String|int|null} svc_id If not specified - toggle badges for all svcs - on page, if segment_id is not specified, otherwise - in segment
     * @private
     */
    SvcsScreenOtherMeal.prototype.__badgeToggle = function (type, state, segment_id = null, svc_id = null) {
        var that = this,
            $svc_segment = segment_id
                ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-segment-id=' + segment_id + ']')
                : that.$wrapper.find('.' + that.class.svc_card_wrapper),
            $svc = svc_id
                ? $svc_segment.filter('[data-airline-svc-id="' + svc_id + '"]')
                : $svc_segment,
            badge_class = that.class['svc_badge_' + type],
            $svc_badge = $svc.find('.' + badge_class);
        $svc_badge.toggle(state);
    };

    SvcsScreenOtherMeal.prototype.__badgeSetQuantity = function (type, segment_id, svc_id, quantity = 0) {
        var that = this,
            $svc_segment = segment_id
                ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-segment-id=' + segment_id + ']')
                : that.$wrapper.find('.' + that.class.svc_card_wrapper),
            $svc = svc_id
                ? $svc_segment.filter('[data-airline-svc-id="' + svc_id + '"]')
                : $svc_segment,
            badge_class = that.class['svc_badge_' + type],
            badge_quantity_class = that.class['svc_badge_' + type + '_quantity'],
            $svc_badge = $svc.find('.' + badge_class),
            $svc_badge_quantity = $svc_badge.find('.' + badge_quantity_class);

        if (!quantity) {
            $svc_badge_quantity.hide();
        } else {
            $svc_badge_quantity.text('x' + quantity).show();
        }
    };

    SvcsScreenOtherMeal.prototype.__setSvcActionStateFor = function (segment_id, item_id, item_quantity) {
        var that = this,
            state = that.__defineSvcActionState(item_quantity),
            $svc_segment = that.$wrapper.find('.' + that.class.svc_segment_tab_content + '[data-tab-id="segment-' + segment_id + '"]'),
            $svc_card = $svc_segment.find('.' + that.class.svc_card_wrapper + '[data-airline-svc-id="' + item_id + '"]');

        that.__setSvcsActionState($svc_card, state);
    };

    SvcsScreenOtherMeal.prototype.__defineSvcActionState = function (svc_quantity) {
        if (svc_quantity > 0) {
            return 'edit';
        } else {
            return 'add';
        }
    };

    SvcsScreenOtherMeal.prototype.__setSvcsActionState = function ($svc_card, state) {
        var that = this;

        if (state === 'add') {
            that.__setSvcActionStateAdd($svc_card);
        } else if (state === 'edit') {
            that.__setSvcActionStateEdit($svc_card);
        }
    };

    SvcsScreenOtherMeal.prototype.__setSvcActionStateAdd = function ($svc_card) {
        var that = this,
            $svc_action_edit = $svc_card.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc_card.find('.' + that.class.svc_action_add);

        $svc_action_edit.hide();
        $svc_action_add.show();
    };

    SvcsScreenOtherMeal.prototype.__setSvcActionStateEdit = function ($svc_card) {
        var that = this,
            $svc_action_edit = $svc_card.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc_card.find('.' + that.class.svc_action_add);

        $svc_action_edit.show();
        $svc_action_add.hide();
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitState = function (state, $action = null) {
        var that = this;
        switch (state) {
            case 'added':
                that.__setActionSubmitAdd($action);
                break;
            case 'empty':
                that.__setActionSubmitEmpty($action);
                break;
            case 'confirm':
                that.__setActionSubmitConfirm($action);
                break;
            case 'continue':
                that.__setActionSubmitContinue($action);
                break;
        }
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitEmpty = function () {
        var that = this;
        that.__setActionSubmitTextFor('empty');
        that.__setActionSubmitTypeCancel();
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitAdd = function () {
        var that = this;
        that.__setActionSubmitTextFor('added', (!$.sa.is_desktop() ? ' ' + that.__formatTotalPrice() : ''));
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitConfirm = function () {
        var that = this;
        that.__setActionSubmitTextFor('confirm');
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitContinue = function () {
        var that = this;
        that.__setActionSubmitTextFor('continue');
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitTextFor = function (state, text_append = '') {
        var that = this,
            is_desktop = $.sa.is_desktop(),
            $action = that.$wrapper.find('.' + that.class.svc_action_submit),
            $action_text = is_desktop
                ? $action.find('.' + that.class.svc_action_submit_text_desktop)
                : $action.find('.' + that.class.svc_action_submit_text_mobile),
            text = '' + $action_text.data(state + '-text') + text_append;
        $action_text.text(text);
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitTypeCancel = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action_submit)
            .addClass(that.class.svc_action_cancel)
            .removeClass(that.class.svc_action_confirm);
    };

    SvcsScreenOtherMeal.prototype.__setActionSubmitTypeConfirm = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action_submit)
            .addClass(that.class.svc_action_confirm)
            .removeClass(that.class.svc_action_cancel);
    };

    SvcsScreenOtherMeal.prototype.__setSegmentDrawerActionSubmitState = function (state, $action) {
        var text;
        switch (state) {
            case 'added':
                text = $.sa.locales['add'];
                break;
            case 'empty':
                text = $.sa.locales['continue_without_service'];
                break;
            case 'confirm':
                text = $.sa.locales['confirm'];
                break;
            case 'continue':
                text = $.sa.locales['continue'];
                break;
        }
        $action.text(text);
    };

    SvcsScreenOtherMeal.prototype.__changeTotal = function (value, multiplier = 1) {
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var that = this,
            amount = value * multiplier;

        if (amount < 0 && that.total < Math.abs(amount)) {
            $.sa.log('Error count total price');
        } else {
            that.total += amount;
        }
    };

    SvcsScreenOtherMeal.prototype.__formatTotalPrice = function () {
        var that = this;
        return $.sa.format.price(that.total, that.order_currency);
    };

    SvcsScreenOtherMeal.prototype.__displayTotal = function () {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        var $total_amount = that.$wrapper.find('.' + that.class.svc_total),
            total_amount_text = that.__formatTotalPrice();

        $total_amount.text(total_amount_text);
    };

    SvcsScreenOtherMeal.prototype.__svcAirlineToggleHintPosition = function (category_id = 'all') {
        var that = this,
            $svcs_tab_content = that.$wrapper.find('.' + that.class.svc_segment_tab_content),
            svcs_selector = (category_id !== 'all')
                ? '.' + that.class.svc_card_wrapper + '[data-category-id="' + category_id + '"]'
                : '.' + that.class.svc_card_wrapper;

        $svcs_tab_content.each(function (){
            var $tab_content = $(this),
                $svcs = $tab_content.find(svcs_selector),
                $svc_first = $svcs.first(),
                $svc_others = $svc_first.siblings(svcs_selector),
                $svc_first_hint = $svc_first.find('.' + that.class.svc_hint),
                $svc_others_hint = $svc_others.find('.' + that.class.svc_hint);

            if ($svc_first_hint.length) {
                $svc_first_hint.removeClass(that.class.svc_hint_top);
            }
            $svc_others_hint.addClass(that.class.svc_hint_top);
        });
    };

    SvcsScreenOtherMeal.prototype.__toggleSvcsContentStickyHeader = function ($action, $parent) {
        var that = this,
            $svc_card = $action.parents('.' + that.class.svc_card_wrapper),
            $svc_content = $svc_card.find('.' + that.class.svc_content),
            $svc_border = $svc_card.find('.' + that.class.svc_border);

        if (!UIToggle.prototype.isActive($svc_content)) {
            $svc_border.addClass(that.class.sticky)
        } else {
            $svc_border.removeClass(that.class.sticky);
        }
    };

    SvcsScreenOtherMeal.prototype.__initSegmentTabs = function() {
        const that = this;

        //
        const classes = {
            active_segment_class : 'is-active',
            active_category_class: 'is-active',
            hidden_category_class: 'hidden'
        };

        const selectors = {
            tab_segment: '.js-tab-meal-segment'
        };

        // DOM
        const $segments_wrapper = that.$wrapper.find('.js-tabs-meal-segments'),
              $categories_wrapper = that.$wrapper.find('.js-svc-meal-categories'),
              $categories = $categories_wrapper.find('.js-svc-meal-category');

        // VARS
        const items_map = getItemsMap();

        let active_segment_id = getActiveSegmentId();

        // INIT

        filterCategories(active_segment_id);

        $segments_wrapper.on('click', selectors.tab_segment, function() {
            const $segment = $(this);

            active_segment_id = getActiveSegmentId($segment);
            filterCategories(active_segment_id);
        });

        // FUNCTIONS

        /**
         * @param {jQuery?} $segment
         * @return {String}
         * */
        function getActiveSegmentId($segment = null) {
            $segment = ($segment ? $segment : $segments_wrapper.find(selectors.tab_segment + '.' + classes.active_segment_class));
            return $segment.data('segment-id') + '';
        };

        /**
         * @param {String} active_segment_id
         * */
        function filterCategories(active_segment_id) {
            const segment = items_map[active_segment_id];

            $categories.each( function() {
                const $category = $(this),
                      category_id = $category.data('id') + '';

                if (!segment) {
                    displayCategory($category, false);
                } else if (category_id === 'all') {
                    displayCategory($category, true);
                } else {
                    displayCategory($category, !!segment[category_id]);
                }
            });

            function displayCategory($category, display = true) {
                if (display) {
                    $category.show();
                } else {
                    $category.hide();
                }
            }

            function getSegmentsWithCategories() {
                const segments = {};

                that.meal_items.forEach( function(meal_item) {
                    if (!segments[meal_item.segment_id]) {
                        segments[meal_item.segment_id] = {
                            categories: {}
                        }
                    }

                    const segment = segments[meal_item.segment_id];

                    if (!segment.categories[meal_item.category_id]) {
                        segment.categories[meal_item.category_id] = {
                            meal_items: {}
                        }
                    }

                    const category = segment.categories[meal_item.category_id];
                    category.meal_items[meal_item.meal_item_id] = meal_item;
                });

                return segments;
            }
        }

        /**
         * @return {Object}
         * */
        function getItemsMap() {
            const result = {};

            that.$wrapper.find('.js-svc-card-wrapper').each( function() {
                const $item = $(this),
                      segment_id = $item.data('segment-id') + '',
                      category_id = $item.data('category-id') + '',
                      svc_id = $item.data('airline-svc-id') + '';

                if (!result[segment_id]) {
                    result[segment_id] = {};
                }

                if (!result[segment_id][category_id]) {
                    result[segment_id][category_id] = {};
                }

                result[segment_id][category_id][svc_id] = true;
            });
            
            return result;
        }
    };

    return SvcsScreenOtherMeal;
})($);
